import DestructorTree from "../DestructorTree";
export function wrapNode(parentDom: () => Node, destructor: DestructorTree): () => HTMLElement {
	return () => {
		const control_root = parentDom();
		const dynamic_area = document.createComment("--DYNAMIC AREA--");
		let childNodes: ChildNode[] = [];
		dynamic_area.appendChild = function (node) {
			if (destructor.destroyed) {
				return node;
			}
			childNodes.push(node as unknown as ChildNode);
			return control_root.insertBefore(node, dynamic_area);
		};
		dynamic_area.insertBefore = function (node, child) {
			if (destructor.destroyed) {
				return node;
			}
			return control_root.insertBefore(node, child);
		};
		const old_remove = dynamic_area.remove;
		dynamic_area.remove = function (...args) {
			for (const i in childNodes) {
				if (childNodes[i] !== undefined) {
					childNodes[i].remove();
				}
			}
			childNodes = [];
			old_remove.apply(dynamic_area, args);
		};
		control_root.appendChild(dynamic_area);
		destructor.onDestroy(() => {
			dynamic_area.remove();
		});
		return dynamic_area as unknown as HTMLElement; //FIXME: visit_widget_implementatio_node should accepts Node instead of HTMLElement
	};
}
